<template>
  <main class="accounting">
    <h1 class="accounting__title" v-if="!isPermissions.acc_multi_payments">Accounting</h1>
    <div class="accounting__tabs" v-if="isPermissions.acc_multi_payments">
      <p :class="{ selected: selectedTab === 1 }" @click="switchTab(1)">Единоразовые выплаты</p>
      <p :class="{ selected: selectedTab === 2 }" @click="switchTab(2)">Регулярные выплаты</p>
    </div>
    <div class="accounting__content" v-if="selectedTab === 1">
      <div class="accounting__form">
        <div class="accounting__form__input">
          <span>Выберите проект:</span>
          <div class="accounting__form__input__wrapper select" @click="openSelectProject">
            <p>{{ selectedProject }}</p>
            <img
              :class="{ rotate: selectsOpen.project }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="select__dropDown" v-if="selectsOpen.project">
            <span
              class="select__dropDown__item"
              v-for="(project, index) in projects"
              :key="index"
              v-if="project !== selectedProject"
              @click="selectProject(index)"
            >
              {{ project }}
            </span>
          </div>
        </div>
        <div class="accounting__form__input">
          <span>Тип выплаты:</span>
          <div class="accounting__form__input__wrapper select" @click="openSelectKind">
            <p>{{ selectedKind }}</p>
            <img
              :class="{ rotate: selectsOpen.kind }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="select__dropDown" v-if="selectsOpen.kind">
            <span
              class="select__dropDown__item"
              v-for="(kind, key) in kinds"
              :key="key"
              v-if="kind !== selectedKind"
              @click="selectKind(key)"
            >
              {{ kind }}
            </span>
          </div>
        </div>
        <div class="accounting__form__input" v-if="selectedKind === kinds.once">
          <span>ФИО сотрудника:</span>
          <div class="accounting__form__input__wrapper">
            <input type="text" placeholder="Введите данные:" v-model="employeeName" />
          </div>
        </div>
        <div class="accounting__form__input" v-if="selectedKind === kinds.once">
          <span>Выберите департамент:</span>
          <div class="accounting__form__input__wrapper select" @click="openSelectDepartment">
            <p>{{ selectedDepartment }}</p>
            <img
              :class="{ rotate: selectsOpen.department }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="select__dropDown" v-if="selectsOpen.department">
            <span
              class="select__dropDown__item"
              v-for="(department, key) in departments"
              :key="key"
              v-if="department !== selectedDepartment"
              @click="selectDepartment(key)"
            >
              {{ department }}
            </span>
          </div>
        </div>
        <div
          class="accounting__form__input"
          v-if="selectedKind === kinds.once && directionsForSelected"
        >
          <span>Выберите направление:</span>
          <div class="accounting__form__input__wrapper select" @click="openSelectDirection">
            <p>{{ selectedDirection }}</p>
            <img
              :class="{ rotate: selectsOpen.direction }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="select__dropDown" v-if="selectsOpen.direction">
            <span
              class="select__dropDown__item"
              v-for="(direction, key) in directionsForSelected"
              :key="key"
              v-if="direction !== selectedDirection"
              @click="selectDirection(direction)"
            >
              {{ direction }}
            </span>
          </div>
        </div>
        <div class="accounting__form__input" v-if="selectedKind === kinds.other">
          <span>Выберите категорию:</span>
          <div class="accounting__form__input__wrapper select" @click="openSelectTarget">
            <p>{{ selectedTarget }}</p>
            <img
              :class="{ rotate: selectsOpen.target }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="select__dropDown" v-if="selectsOpen.target">
            <span
              class="select__dropDown__item"
              v-for="(item, key) in target"
              :key="key"
              v-if="key !== selectedTarget"
              @click="selectTarget(key)"
            >
              {{ key }}
            </span>
          </div>
        </div>
        <div class="accounting__form__input" v-if="selectedKind === kinds.other">
          <span>Ответственный департамент:</span>
          <div class="accounting__form__input__wrapper select" @click="openSelectDepartment">
            <p>{{ selectedDepartment }}</p>
            <img
              :class="{ rotate: selectsOpen.department }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="select__dropDown" v-if="selectsOpen.department">
            <span
              class="select__dropDown__item"
              v-for="(department, key) in departments"
              :key="key"
              v-if="department !== selectedDepartment"
              @click="selectDepartment(key)"
            >
              {{ department }}
            </span>
          </div>
        </div>
        <div class="accounting__form__input" v-if="selectedKind === kinds.other">
          <span>Подробнее:</span>
          <div class="accounting__form__input__wrapper">
            <input type="text" placeholder="Подробнее о выплате:" v-model="moreInfo" />
          </div>
        </div>
        <div class="accounting__form__input">
          <span>Выберите валюту:</span>
          <div class="accounting__form__input__wrapper select" @click="openSelectCurrency">
            <p>{{ selectedCurrency }}</p>
            <img
              :class="{ rotate: selectsOpen.currency }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="select__dropDown" v-if="selectsOpen.currency">
            <span
              class="select__dropDown__item"
              v-for="(currency, key) in currencyMap"
              :key="key"
              v-if="currency !== selectedCurrency"
              @click="selectCurrency(key)"
            >
              {{ currency }}
            </span>
          </div>
        </div>
        <div class="accounting__form__input">
          <span>Выберите валюту для бухгалтерии:</span>
          <div
            class="accounting__form__input__wrapper select"
            @click="openSelectCurrencyAccounting"
          >
            <p>{{ selectedCurrencyAccounting }}</p>
            <img
              :class="{ rotate: selectsOpen.currencyAccounting }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="select__dropDown" v-if="selectsOpen.currencyAccounting">
            <span
              class="select__dropDown__item"
              v-for="(currency, key) in currencyMap"
              :key="key"
              v-if="currency !== selectedCurrencyAccounting"
              @click="selectCurrency(key, true)"
            >
              {{ currency }}
            </span>
          </div>
        </div>
        <div class="accounting__form__input">
          <span>Выберите дату для отчетности:</span>
          <div class="accounting__form__input__calendar">
            <DatePicker
              v-if="openedCalendar"
              v-on:input="getCorrectDate"
              v-bind:value="accountingDate"
              is-dark
              :modelConfig="modelConfig"
            >
            </DatePicker>
          </div>
          <div
            class="accounting__form__calendarValue accounting__form__input__wrapper"
            @click="openCalendar"
          >
            <span>{{ accountingDate.split('.')[0].split('T')[0] }}</span>
          </div>
        </div>
        <div class="accounting__form__input">
          <span>Сумма выплаты:</span>
          <div class="accounting__form__input__wrapper">
            <input type="number" placeholder="Amount" v-model="amount" />
          </div>
        </div>
        <div class="accounting__form__input">
          <span>Выберите метод:</span>
          <div class="accounting__form__input__wrapper select" @click="openSelectType">
            <p>{{ selectedType }}</p>
            <img
              :class="{ rotate: selectsOpen.payoutType }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="select__dropDown" v-if="selectsOpen.payoutType">
            <span
              class="select__dropDown__item"
              v-for="(paymentKey, paymentName) in payoutType[getKeyByValue()]"
              :key="paymentKey"
              v-if="selectedType !== paymentName.charAt(0).toUpperCase() + paymentName.slice(1)"
              @click="selectType(paymentName, paymentKey)"
            >
              {{ paymentName }}
            </span>
          </div>
          <div
            v-if="selectedType === 'Gm_cards'"
            class="accounting__form__input__chooseCard"
            @click="openGmCardsMenu"
          >
            <div class="accounting__form__input__chooseCard__info">
              <img src="../../assets/images/card.svg" alt="card" />
              <input type="text" placeholder="Card" v-model="gmCard" @input="onChangeGmCard" />
            </div>
            <span>
              <svg
                width="10"
                height="11"
                viewBox="0 0 10 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.93746 5.81712C9.89779 5.91932 9.83829 6.0127 9.76239 6.09189L5.59399 10.2551C5.51626 10.3328 5.42398 10.3943 5.32242 10.4364C5.22086 10.4784 5.11201 10.5 5.00208 10.5C4.78007 10.5 4.56715 10.4119 4.41017 10.2551C4.33244 10.1775 4.27078 10.0853 4.22871 9.98389C4.18664 9.88246 4.16499 9.77374 4.16499 9.66395C4.16499 9.44221 4.25318 9.22956 4.41017 9.07277L7.16131 6.33336L0.83368 6.33336C0.612574 6.33336 0.400525 6.24563 0.244179 6.08948C0.087834 5.93333 0 5.72154 0 5.50071C0 5.27988 0.087834 5.06809 0.244179 4.91194C0.400525 4.75579 0.612574 4.66806 0.83368 4.66806L7.16131 4.66806L4.41017 1.92865C4.33203 1.85125 4.27001 1.75916 4.22768 1.65769C4.18536 1.55623 4.16357 1.44739 4.16357 1.33747C4.16357 1.22756 4.18536 1.11872 4.22768 1.01726C4.27001 0.915792 4.33203 0.823702 4.41017 0.746296C4.48767 0.668253 4.57987 0.606308 4.68146 0.564035C4.78306 0.521763 4.89202 0.5 5.00208 0.5C5.11213 0.5 5.2211 0.521763 5.32269 0.564035C5.42428 0.606308 5.51649 0.668253 5.59399 0.746296L9.76239 4.90953C9.83829 4.98872 9.89779 5.0821 9.93746 5.1843C10.0208 5.38702 10.0208 5.6144 9.93746 5.81712Z"
                  fill="#A1A1A1"
                />
              </svg>
            </span>
          </div>
          <a
            v-if="selectedType === 'Gm_cards'"
            :href="cardsMenu.addCardLink"
            target="_blank"
            class="accounting__form__input__chooseCard__menu__add"
          >
            <p>Add new card</p>
            <img src="../../assets/images/plus.svg" alt="plus" />
          </a>
          <div
            v-if="cardsMenu.showList && filtredGmCards.length"
            class="accounting__form__input__chooseCard__menu"
          >
            <div
              class="card"
              v-for="(card, index) in filtredGmCards"
              :key="index"
              @click="selectCard(index)"
            >
              <img src="../../assets/images/card.svg" alt="card" />
              <p>{{ card }}</p>
            </div>
          </div>
        </div>
        <div
          class="accounting__form__input"
          v-if="selectedType === 'Credit_card' || selectedType === 'Cardlink_sbp'"
        >
          <span>Имя:</span>
          <div class="accounting__form__input__wrapper">
            <input type="text" placeholder="First name" v-model="firstName" />
          </div>
        </div>
        <div
          class="accounting__form__input"
          v-if="selectedType === 'Credit_card' || selectedType === 'Cardlink_sbp'"
        >
          <span>Фамилия:</span>
          <div class="accounting__form__input__wrapper">
            <input type="text" placeholder="Second name" v-model="secondName" />
          </div>
        </div>
        <div class="accounting__form__input" v-if="selectedType === 'Sbp'">
          <span>Выберите банк:</span>
          <div class="accounting__form__input__wrapper select" @click="openSelectBank">
            <p>{{ selectedBank.name ? selectedBank.name : selectedBank }}</p>
            <img
              :class="{ rotate: selectsOpen.bank }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="select__dropDown" v-if="selectsOpen.bank">
            <div class="accounting__form__input__wrapper bankName">
              <input type="text" placeholder="Название банка" v-model="bankName" />
            </div>
            <span
              class="select__dropDown__item"
              v-for="(bank, index) in sbpBanks"
              :key="index"
              v-if="
                bank.id !== selectedFkBank.id &&
                bank.name.toLowerCase().includes(bankName.toLowerCase())
              "
              @click="selectBank(bank)"
            >
              {{ bank.name }}
            </span>
          </div>
        </div>
        <div class="accounting__form__input" v-if="selectedType === 'Cardlink_sbp'">
          <span>Выберите банк:</span>
          <div class="accounting__form__input__wrapper select" @click="openSelectBank">
            <p>
              {{ selectedCardLinkBank.name ? selectedCardLinkBank.name : selectedCardLinkBank }}
            </p>
            <img
              :class="{ rotate: selectsOpen.bank }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="select__dropDown" v-if="selectsOpen.bank">
            <div class="accounting__form__input__wrapper bankName">
              <input type="text" placeholder="Название банка" v-model="bankName" />
            </div>
            <span
              class="select__dropDown__item"
              v-for="(bank, index) in cardLinkSbpMethods"
              :key="index"
              v-if="
                bank.member_id !== selectedCardLinkBank.member_id &&
                bank.name.toLowerCase().includes(bankName.toLowerCase())
              "
              @click="selectCardLinkBank(bank)"
            >
              {{ bank.name }}
            </span>
          </div>
        </div>
        <div class="accounting__form__input" v-if="selectedType === 'Fkwallet_sbp'">
          <span>Выберите банк:</span>
          <div class="accounting__form__input__wrapper select" @click="openSelectBank">
            <p>{{ selectedFkBank.name ? selectedFkBank.name : selectedFkBank }}</p>
            <img
              :class="{ rotate: selectsOpen.bank }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="select__dropDown" v-if="selectsOpen.bank">
            <div class="accounting__form__input__wrapper bankName">
              <input type="text" placeholder="Название банка" v-model="bankName" />
            </div>
            <span
              class="select__dropDown__item"
              v-for="(bank, index) in fkSbpBanks"
              :key="index"
              v-if="
                bank.id !== selectedFkBank.id &&
                bank.name.toLowerCase().includes(bankName.toLowerCase())
              "
              @click="selectFkBank(bank)"
            >
              {{ bank.name }}
            </span>
          </div>
        </div>
        <div class="accounting__form__input" v-if="selectedType !== 'Gm_cards'">
          <span>{{ selectedType === 'Sbp' ? 'Номер телефона:' : 'Кошелек:' }}</span>
          <div class="accounting__form__input__wrapper">
            <input type="text" placeholder="Wallet" v-model="wallet" />
          </div>
        </div>
        <div class="accounting__form__input">
          <span>Two-factor:</span>
          <div class="accounting__form__input__wrapper">
            <input type="number" placeholder="Two-factor" v-model="twoFactor" />
          </div>
        </div>
      </div>
      <div class="accounting__form__info">
        <p class="accounting__form__info__title">Withdrawal Information :</p>
        <div class="accounting__form__info__items">
          <div class="accounting__form__info__item" v-if="isPermissions.admin_payments">
            <span>Available balance:</span>
            <span>{{ $store.state.balance }} {{ currencyMap[$store.state.currency] }}</span>
          </div>
          <div class="accounting__form__info__item">
            <span>Commission :</span>
            <span v-if="fixCommission > 0">
              {{ fixPercentCommission }}% + {{ fixCommission }} {{ selectedCurrency }}
            </span>
            <span v-if="fixCommission === 0"> {{ fixPercentCommission }}% </span>
          </div>
          <div class="accounting__form__info__item">
            <span>Min :</span>
            <span v-if="selectedType !== 'Select type'"
              >{{ minWithdraw }} {{ selectedCurrency }}</span
            >
          </div>
          <div class="accounting__form__info__item">
            <span>Max :</span>
            <span v-if="selectedType !== 'Select type'"
              >{{ maxWithdraw }} {{ selectedCurrency }}</span
            >
          </div>
          <div class="accounting__form__info__item">
            <span>Total :</span>
            <span v-if="totalWithCommission">{{ totalWithCommission }} {{ selectedCurrency }}</span>
          </div>
          <div class="accounting__form__info__item">
            <span>The user will receive :</span>
            <span>{{ amount }} {{ selectedCurrency }}</span>
          </div>
        </div>
        <div class="accounting__form__btn__wrapper">
          <button @click="withDraw" :class="{ disable: isBtnDisable || withdrawButtonDisable }">
            Создать запрос
          </button>
        </div>
        <p class="accounting__form__success__info" v-if="success">Успешно</p>
        <p class="accounting__form__success__info error" v-if="error">Ошибка</p>
      </div>
    </div>
    <Loader v-if="regularPaymentsLoader" />
    <div class="accounting__regular" v-if="selectedTab === 2 && !regularPaymentsLoader">
      <div class="accounting__regular__add">
        <div class="add" v-if="!createRegularPaymentFormOpen && !isEditingRegularOpen">
          <p class="success" v-if="regularPaymentSuccess">Успешно</p>
          <button @click="openRegularForm">Создать новую</button>
        </div>
        <div
          class="accounting__regular__form"
          v-if="createRegularPaymentFormOpen || isEditingRegularOpen"
        >
          <div class="accounting__form__input">
            <span>Выберите проект:</span>
            <div class="accounting__form__input__wrapper select" @click="openSelectProject">
              <p>{{ selectedProject }}</p>
              <img
                :class="{ rotate: selectsOpen.project }"
                src="../../assets/images/down-arrow.svg"
                alt="open"
              />
            </div>
            <div class="select__dropDown" v-if="selectsOpen.project">
              <span
                class="select__dropDown__item"
                v-for="(project, index) in projects"
                :key="index"
                v-if="project !== selectedProject"
                @click="selectProject(index)"
              >
                {{ project }}
              </span>
            </div>
          </div>
          <div class="accounting__form__input">
            <span>ФИО сотрудника:</span>
            <div class="accounting__form__input__wrapper">
              <input type="text" placeholder="Введите данные:" v-model="employeeName" />
            </div>
          </div>
          <div class="accounting__form__input">
            <span>Выберите департамент:</span>
            <div class="accounting__form__input__wrapper select" @click="openSelectDepartment">
              <p>{{ selectedDepartment }}</p>
              <img
                :class="{ rotate: selectsOpen.department }"
                src="../../assets/images/down-arrow.svg"
                alt="open"
              />
            </div>
            <div class="select__dropDown" v-if="selectsOpen.department">
              <span
                class="select__dropDown__item"
                v-for="(department, key) in departments"
                :key="key"
                v-if="department !== selectedDepartment"
                @click="selectDepartment(key)"
              >
                {{ department }}
              </span>
            </div>
          </div>
          <div class="accounting__form__input" v-if="directionsForSelected">
            <span>Выберите направление:</span>
            <div class="accounting__form__input__wrapper select" @click="openSelectDirection">
              <p>{{ selectedDirection }}</p>
              <img
                :class="{ rotate: selectsOpen.direction }"
                src="../../assets/images/down-arrow.svg"
                alt="open"
              />
            </div>
            <div class="select__dropDown" v-if="selectsOpen.direction">
              <span
                class="select__dropDown__item"
                v-for="(direction, key) in directionsForSelected"
                :key="key"
                v-if="direction !== selectedDirection"
                @click="selectDirection(direction)"
              >
                {{ direction }}
              </span>
            </div>
          </div>
          <div class="accounting__form__input">
            <span>Подробнее:</span>
            <div class="accounting__form__input__wrapper">
              <input type="text" placeholder="Подробнее:" v-model="moreInfo" />
            </div>
          </div>
          <div class="accounting__form__input">
            <span>Выберите валюту:</span>
            <div class="accounting__form__input__wrapper select" @click="openSelectCurrency">
              <p>{{ selectedCurrency }}</p>
              <img
                :class="{ rotate: selectsOpen.currency }"
                src="../../assets/images/down-arrow.svg"
                alt="open"
              />
            </div>
            <div class="select__dropDown" v-if="selectsOpen.currency">
              <span
                class="select__dropDown__item"
                v-for="(currency, key) in currencyMap"
                :key="key"
                v-if="currency !== selectedCurrency"
                @click="selectCurrency(key)"
              >
                {{ currency }}
              </span>
            </div>
          </div>
          <div class="accounting__form__input">
            <span>Выберите валюту для бухгалтерии:</span>
            <div
              class="accounting__form__input__wrapper select"
              @click="openSelectCurrencyAccounting"
            >
              <p>{{ selectedCurrencyAccounting }}</p>
              <img
                :class="{ rotate: selectsOpen.currencyAccounting }"
                src="../../assets/images/down-arrow.svg"
                alt="open"
              />
            </div>
            <div class="select__dropDown" v-if="selectsOpen.currencyAccounting">
              <span
                class="select__dropDown__item"
                v-for="(currency, key) in currencyMap"
                :key="key"
                v-if="currency !== selectedCurrencyAccounting"
                @click="selectCurrency(key, true)"
              >
                {{ currency }}
              </span>
            </div>
          </div>
          <div class="accounting__form__input">
            <span>Выберите метод:</span>
            <div class="accounting__form__input__wrapper select">
              <p class="methodOpen" @click="openSelectType">{{ selectedType }}</p>
              <img
                :class="{ rotate: selectsOpen.payoutType }"
                src="../../assets/images/down-arrow.svg"
                alt="open"
              />
              <div class="select__dropDown regularPaymentMethod" v-if="selectsOpen.payoutType">
                <span
                  class="select__dropDown__item"
                  v-for="(paymentKey, paymentName) in payoutType[getKeyByValue()]"
                  :key="paymentKey"
                  v-if="selectedType !== paymentName.charAt(0).toUpperCase() + paymentName.slice(1)"
                  @click="selectType(paymentName, paymentKey)"
                >
                  {{ paymentName }}
                </span>
              </div>
            </div>
          </div>
          <div class="accounting__form__input" v-if="selectedType === 'Sbp'">
            <span>Выберите банк:</span>
            <div class="accounting__form__input__wrapper select" @click="openSelectBank">
              <p>{{ selectedBank.name ? selectedBank.name : selectedBank }}</p>
              <img
                :class="{ rotate: selectsOpen.bank }"
                src="../../assets/images/down-arrow.svg"
                alt="open"
              />
            </div>
            <div class="select__dropDown" v-if="selectsOpen.bank">
              <div class="accounting__form__input__wrapper bankName">
                <input type="text" placeholder="Название банка" v-model="bankName" />
              </div>
              <span
                class="select__dropDown__item"
                v-for="(bank, index) in sbpBanks"
                :key="index"
                v-if="
                  bank.id !== selectedFkBank.id &&
                  bank.name.toLowerCase().includes(bankName.toLowerCase())
                "
                @click="selectBank(bank)"
              >
                {{ bank.name }}
              </span>
            </div>
          </div>
          <div class="accounting__form__input" v-if="selectedType === 'Fkwallet_sbp'">
            <span>Выберите банк:</span>
            <div class="accounting__form__input__wrapper select" @click="openSelectBank">
              <p>{{ selectedFkBank.name ? selectedFkBank.name : selectedFkBank }}</p>
              <img
                :class="{ rotate: selectsOpen.bank }"
                src="../../assets/images/down-arrow.svg"
                alt="open"
              />
            </div>
            <div class="select__dropDown" v-if="selectsOpen.bank">
              <div class="accounting__form__input__wrapper bankName">
                <input type="text" placeholder="Название банка" v-model="bankName" />
              </div>
              <span
                class="select__dropDown__item"
                v-for="(bank, index) in fkSbpBanks"
                :key="index"
                v-if="
                  bank.id !== selectedFkBank.id &&
                  bank.name.toLowerCase().includes(bankName.toLowerCase())
                "
                @click="selectFkBank(bank)"
              >
                {{ bank.name }}
              </span>
            </div>
          </div>
          <div class="gmCards" v-if="selectedType === 'Gm_cards'">
            <div v-if="selectedType === 'Gm_cards'" class="accounting__form__input__chooseCard">
              <div class="accounting__form__input__chooseCard__info">
                <img src="../../assets/images/card.svg" alt="card" />
                <input
                  type="text"
                  placeholder="Card"
                  v-model="gmCard"
                  @click="openGmCardsMenu"
                  @input="onChangeGmCard"
                />
                <div
                  v-if="cardsMenu.showList && filtredGmCards.length"
                  class="accounting__form__input__chooseCard__menu"
                >
                  <div
                    class="card"
                    v-for="(card, index) in filtredGmCards"
                    :key="index"
                    @click="selectCard(index)"
                  >
                    <img src="../../assets/images/card.svg" alt="card" />
                    <p>{{ card }}</p>
                  </div>
                </div>
              </div>
              <span>
                <svg
                  width="10"
                  height="11"
                  viewBox="0 0 10 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.93746 5.81712C9.89779 5.91932 9.83829 6.0127 9.76239 6.09189L5.59399 10.2551C5.51626 10.3328 5.42398 10.3943 5.32242 10.4364C5.22086 10.4784 5.11201 10.5 5.00208 10.5C4.78007 10.5 4.56715 10.4119 4.41017 10.2551C4.33244 10.1775 4.27078 10.0853 4.22871 9.98389C4.18664 9.88246 4.16499 9.77374 4.16499 9.66395C4.16499 9.44221 4.25318 9.22956 4.41017 9.07277L7.16131 6.33336L0.83368 6.33336C0.612574 6.33336 0.400525 6.24563 0.244179 6.08948C0.087834 5.93333 0 5.72154 0 5.50071C0 5.27988 0.087834 5.06809 0.244179 4.91194C0.400525 4.75579 0.612574 4.66806 0.83368 4.66806L7.16131 4.66806L4.41017 1.92865C4.33203 1.85125 4.27001 1.75916 4.22768 1.65769C4.18536 1.55623 4.16357 1.44739 4.16357 1.33747C4.16357 1.22756 4.18536 1.11872 4.22768 1.01726C4.27001 0.915792 4.33203 0.823702 4.41017 0.746296C4.48767 0.668253 4.57987 0.606308 4.68146 0.564035C4.78306 0.521763 4.89202 0.5 5.00208 0.5C5.11213 0.5 5.2211 0.521763 5.32269 0.564035C5.42428 0.606308 5.51649 0.668253 5.59399 0.746296L9.76239 4.90953C9.83829 4.98872 9.89779 5.0821 9.93746 5.1843C10.0208 5.38702 10.0208 5.6144 9.93746 5.81712Z"
                    fill="#A1A1A1"
                  />
                </svg>
              </span>
            </div>
            <a
              v-if="selectedType === 'Gm_cards'"
              :href="cardsMenu.addCardLink"
              target="_blank"
              class="accounting__form__input__chooseCard__menu__add"
            >
              <p>Add new card</p>
              <img src="../../assets/images/plus.svg" alt="plus" />
            </a>
          </div>
          <div class="accounting__form__input">
            <span>Сумма регулярной выплаты:</span>
            <div class="accounting__form__input__wrapper">
              <input type="number" placeholder="Amount" v-model="amount" />
            </div>
          </div>
          <div class="accounting__form__input" v-if="selectedType !== 'Gm_cards'">
            <span>Кошелек:</span>
            <div class="accounting__form__input__wrapper">
              <input type="text" placeholder="Wallet" v-model="wallet" />
            </div>
          </div>
          <div class="accounting__form__input">
            <span>Тип выплаты:</span>
            <div
              class="accounting__form__input__wrapper select"
              @click="openSelectTypeRegularPayment"
            >
              <p>{{ selectedRegularType }}</p>
              <img
                :class="{ rotate: selectsOpen.regularType }"
                src="../../assets/images/down-arrow.svg"
                alt="open"
              />
            </div>
            <div class="select__dropDown" v-if="selectsOpen.regularType">
              <span
                class="select__dropDown__item"
                v-for="(type, key) in regularTypes"
                :key="key"
                v-if="type !== selectedRegularType"
                @click="selectRegularType(type)"
              >
                {{ type }}
              </span>
            </div>
          </div>
          <div class="accounting__form__input" v-if="selectedRegularType === 'Месячная выплата'">
            <span>В какое число производить выплату:</span>
            <div class="accounting__form__input__wrapper">
              <input
                type="number"
                placeholder="0 последний день каждого месяца"
                v-model="monthlyDay"
              />
            </div>
          </div>
          <div
            class="accounting__form__input"
            v-if="selectedRegularType === 'Интервальная выплата'"
          >
            <span>Выберите день начала выплаты:</span>
            <div id="app" class="accounting__form__calendar">
              <DatePicker
                v-if="openedCalendar"
                v-on:input="getCorrectDate"
                v-bind:value="startPaymentDate"
                is-dark
                :modelConfig="modelConfig"
              >
              </DatePicker>
            </div>
            <div class="accounting__form__calendarValue">
              <span @click="openCalendar">{{ startPaymentDate.split('.')[0].split('T')[0] }}</span>
            </div>
          </div>
          <div
            class="accounting__form__input"
            v-if="selectedRegularType === 'Интервальная выплата'"
          >
            <span>Интервал выплаты в днях:</span>
            <div class="accounting__form__input__wrapper">
              <input type="number" placeholder="Введите интервал" v-model="delta" />
            </div>
          </div>
          <div class="accounting__form__input">
            <span>Two-factor:</span>
            <div class="accounting__form__input__wrapper">
              <input type="number" placeholder="Two-factor" v-model="twoFactor" />
            </div>
          </div>
          <div class="accounting__regular__form__buttons">
            <button
              v-if="!isEditingRegularOpen"
              class="create"
              :class="{ disable: isCreateRegularBtnDisable || withdrawButtonDisable }"
              @click="createRegularPayment"
            >
              Создать выплату
            </button>
            <button
              v-if="isEditingRegularOpen"
              class="create"
              :class="{ disable: isCreateRegularBtnDisable || withdrawButtonDisable }"
              @click="editRegularPayment"
            >
              Изменить выплату
            </button>
            <button class="close" @click="closeRegularForm">Закрыть</button>
          </div>
          <p v-if="regularPaymentError" class="accounting__regular__form__error">Ошибка</p>
        </div>
      </div>
      <div class="accounting__regular__table">
        <table>
          <thead>
            <tr>
              <td>Name</td>
              <td>Id</td>
              <td>Wallet</td>
              <td>Amount</td>
              <td>Accounting info</td>
              <td>Created date</td>
              <td>Editing</td>
              <td>Delete</td>
            </tr>
          </thead>
          <tbody :class="{ formOpen: createRegularPaymentFormOpen || isEditingRegularOpen }">
            <TableRow v-for="row in regularPayments" :row="row" :key="row.id" />
          </tbody>
        </table>
      </div>
      <div class="accounting__regular__delete" v-if="isDeleteRegularPayments.length">
        <div class="accounting__regular__delete__inputWrapper">
          <input type="number" placeholder="2FA" v-model="deleteFa" />
        </div>
        <button :class="{ disable: !deleteFa }" @click="deleteRegularPayment">Удалить</button>
        <p v-if="deleteError">Ошибка</p>
      </div>
    </div>
  </main>
</template>

<script>
import './accounting.scss'

import http from '../../utils/http'
import cookie from 'vue-cookie'
import TableRow from '@/components/AccountingTableRow/AccountingTableRow.vue'
import Loader from '../../components/Loader/Loader'
import { DatePicker } from 'v-calendar'

export default {
  name: 'Accounting',
  components: {
    TableRow,
    Loader,
    DatePicker
  },
  data() {
    return {
      currencyMap: {
        rub: '₽',
        usd: '$',
        eur: '€'
      },
      modelConfig: {
        type: 'string',
        mask: 'iso'
      },
      selectedTab: 1,
      regularPayments: [],
      regularPaymentsLoader: false,
      createRegularPaymentFormOpen: false,
      openedCalendar: false,
      startPaymentDate: 'Select a date',
      accountingDate: 'Select a date',
      regularTypes: {
        monthly: 'Месячная выплата',
        custom: 'Интервальная выплата'
      },
      firstName: '',
      secondName: '',
      amount: 0,
      bankName: '',
      employeeName: null,
      moreInfo: null,
      wallet: null,
      twoFactor: null,
      monthlyDay: null,
      delta: null,
      deleteFa: null,
      deleteError: false,
      selectedType: 'Выберите метод',
      selectedBank: 'Выберите банк',
      selectedFkBank: 'Выберите FK банк',
      selectedCardLinkBank: 'Выберите банк',
      selectedProject: 'Выберите проект',
      selectedKind: 'Тип выплаты',
      selectedDepartment: 'Выберите департамент',
      selectedDirection: 'Выберите направление',
      selectedTarget: 'Выберите категорию',
      selectedSubTarget: 'Выберите подкатегорию',
      selectedCurrency: '₽',
      selectedCurrencyAccounting: '₽',
      selectedRegularType: 'Выберите тип регулярной выплаты',
      withdrawalMethodId: '',
      withdrawButtonDisable: false,
      projects: [],
      kinds: {
        once: 'Зарплата',
        other: 'Сторонние расходы'
      },
      departments: [],
      departmentDirections: {},
      target: [],
      payoutType: {
        rub: {
          yoomoney: '60fc1c99260d106173bc0bfc',
          beeline: '60fc1cf7260d106173bc0bfd',
          bitcoin: '60fc1cc53aad930463b54d05',
          cards: '60fc1c89260d106173bc0bfb',
          tele2: '60fc1cff260d106173bc0bfe',
          gm_cards: '623af9407ba867655b9cb48c',
          sbp: '660852de16a0cb7696a1d5e0',
          mts: '60fc1d114229507674bb9d43',
          tether: '60fc1cd6704e2d2e176a5445',
          tron: '60fc1ce5fe78acaeda629bff',
          tether_trc20: '6214fe51f899a087e28ed794',
          payeer: '60fc1caaf24b40679d75b56f',
          qiwi: '60fc1c90f24b40679d75b56e',
          megaphone: '60fc1d0af24b40679d75b570',
          ethereum: '6214cd52f271fe05579f2c1a',
          card_uah: '65461e850a6408258305ad17',
          fkwallet_cards: '66101034c2a5298d201f7d2b',
          fkwallet_sbp: '661840dfce1d2923d9eaadbb',
          gamemoney: '66b9f49bfa7efa5c8a81b969',
          credit_card: '6887991e69410a59590b92b3',
          cardlink_sbp: '6887ad5469410a59590b92b9'
        },
        usd: {
          ecopayz: '6214d2d3f271fe05579f2c38',
          tether: '6214ce36f271fe05579f2c20',
          ethereum: '6214cd6df271fe05579f2c1c',
          tron: '6214cbe4f271fe05579f2c16',
          gm_cards: '6250246f718fb155294ca656',
          webmoney: '6141bf28a91d235468eb43e0',
          bitcoin: '6214cef3f271fe05579f2c24',
          cards: '6214d12ef271fe05579f2c2c',
          tether_trc20: '6214fe6bf899a087e28ed796',
          gamemoney: '66b9f5aefa7efa5c8a81b970',
          paypal: '67ff7dff5c2d3e5b6ee3d7c7'
        },
        eur: {
          gm_cards: '62502458718fb155294ca655',
          tron: '6214cbedf271fe05579f2c18',
          ethereum: '6214cd88f271fe05579f2c1e',
          tether: '6214ce46f271fe05579f2c22',
          bitcoin: '6214cf0cf271fe05579f2c26',
          tether_trc20: '6214fe73f899a087e28ed798',
          ecopayz: '6214d302f271fe05579f2c3a',
          cards: '6214d139f271fe05579f2c2e',
          gamemoney: '66b9f5bbfa7efa5c8a81b971',
          credit_card: '681112b665e9e1969d9f6620'
        }
      },
      selectsOpen: {
        payoutType: false,
        project: false,
        kind: false,
        department: false,
        direction: false,
        currency: false,
        regularType: false,
        currencyAccounting: false,
        target: false,
        subTarget: false,
        bank: false
      },
      methodsMap: {},
      cardsMenu: {
        showList: false,
        addCardLink: '',
        cards: [],
        selectedCardIndex: 0
      },
      gmCard: '',
      sbpBanks: [],
      fkSbpBanks: [],
      cardLinkSbpMethods: [],
      filtredGmCards: [],
      success: false,
      error: false,
      regularPaymentSuccess: false,
      regularPaymentError: false
    }
  },
  watch: {
    isCurrency: function () {
      this.selectedType = 'Select type'
      this.wallet = ''
    },
    isEditingRegularPayment: function () {
      this.selectedProject = this.isEditingRegularPayment.accounting.project
      this.employeeName = this.isEditingRegularPayment.accounting.recipient
      this.selectedDepartment = this.isEditingRegularPayment.accounting.department
      this.selectedDirection =
        this.isEditingRegularPayment.accounting.direction || 'Выберите направление'
      this.moreInfo = this.isEditingRegularPayment.accounting.desc
      this.selectedCurrency =
        this.currencyMap[this.isEditingRegularPayment.withdrawal.sourceCurrency]
      this.amount = this.isEditingRegularPayment.withdrawal.sourceAmount
      this.wallet = this.isEditingRegularPayment.withdrawal.wallet
      this.selectedRegularType = this.regularTypes[this.isEditingRegularPayment.interval.type]
      this.monthlyDay = this.isEditingRegularPayment.interval.monthlyDay
      this.delta = this.isEditingRegularPayment.interval.delta
      if (this.isEditingRegularPayment.interval.type !== 'monthly') {
        this.startPaymentDate = this.isEditingRegularPayment.interval.startDate
      }
      this.selectedType = 'Выберите метод'
    }
  },
  computed: {
    isPermissions() {
      return this.$store.state.permissions
    },
    isDeleteRegularPayments() {
      return this.$store.state.deleteRegularPayments
    },
    isCurrency() {
      return this.$store.state.currency
    },
    isEditingRegularOpen() {
      return this.$store.state.editingRegularFormOpen
    },
    isEditingRegularPayment() {
      return this.$store.state.editingRegularPayment
    },
    directionsForSelected() {
      const directions = this.departmentDirections[this.selectedDepartment]
      return directions && directions.length ? directions : null
    },
    fixCommission() {
      if (
        this.methodsMap[this.selectedType.toLowerCase()] &&
        this.methodsMap[this.selectedType.toLowerCase()][this.getKeyByValue()]
      ) {
        return this.methodsMap[this.selectedType.toLowerCase()][this.getKeyByValue()].adminFixFee
      }
    },
    fixPercentCommission() {
      if (
        this.methodsMap[this.selectedType.toLowerCase()] &&
        this.methodsMap[this.selectedType.toLowerCase()][this.getKeyByValue()]
      ) {
        return (
          this.methodsMap[this.selectedType.toLowerCase()][this.getKeyByValue()].adminPercentFee *
          100
        ).toFixed(2)
      }
    },
    minWithdraw() {
      if (
        this.methodsMap[this.selectedType.toLowerCase()] &&
        this.methodsMap[this.selectedType.toLowerCase()][this.getKeyByValue()]
      )
        return this.methodsMap[this.selectedType.toLowerCase()][this.getKeyByValue()].adminMinAmount
    },
    maxWithdraw() {
      if (
        this.methodsMap[this.selectedType.toLowerCase()] &&
        this.methodsMap[this.selectedType.toLowerCase()][this.getKeyByValue()]
      )
        return this.methodsMap[this.selectedType.toLowerCase()][this.getKeyByValue()].adminMaxAmount
    },
    totalWithCommission() {
      return (
        Number(this.amount) +
        (Number(this.amount) / 100) * Number(this.fixPercentCommission) +
        this.fixCommission
      )
    },
    isDailyLimit() {
      return this.$store.state.currentDailyLimit
    },
    isBtnDisable() {
      if (
        !this.amount ||
        !this.wallet ||
        !this.twoFactor ||
        this.selectedType === 'Выберите метод' ||
        this.selectedProject === 'Выберите проект' ||
        this.selectedKind === 'Тип выплаты'
      ) {
        return true
      }
      if (
        this.kinds.once === this.selectedKind &&
        (!this.employeeName || this.selectedDepartment === 'Выберите департамент')
      ) {
        return true
      }
      if (
        this.kinds.once === this.selectedKind &&
        this.directionsForSelected &&
        this.selectedDirection === 'Выберите направление'
      ) {
        return true
      }
      if (this.selectedType === 'Sbp' && !this.selectedBank.id) {
        return true
      }
      if (this.selectedType === 'Fkwallet_sbp' && !this.selectedFkBank.id) {
        return true
      }
      if (
        this.kinds.other === this.selectedKind &&
        (!this.moreInfo ||
          this.selectedTarget === 'Выберите категорию' ||
          this.selectedDepartment === 'Выберите департамент')
      ) {
        return true
      }
      return false
    },
    isCreateRegularBtnDisable() {
      if (
        !this.amount ||
        !this.wallet ||
        !this.twoFactor ||
        !this.employeeName ||
        !this.moreInfo ||
        this.selectedType === 'Выберите метод' ||
        this.selectedProject === 'Выберите проект' ||
        this.selectedDepartment === 'Выберите департамент' ||
        this.selectedRegularType === 'Выберите тип регулярной выплаты'
      ) {
        return true
      }

      if (this.directionsForSelected && this.selectedDirection === 'Выберите направление') {
        return true
      }

      if (this.selectedRegularType === 'Месячная выплата' && !String(this.monthlyDay).length) {
        return true
      }

      if (
        this.selectedRegularType === 'Интервальная выплата' &&
        (this.startPaymentDate === 'Select a date' || !this.delta)
      ) {
        return true
      }
      return false
    }
    // isEditingRegularPaymentBtnDisable() {
    //     if (
    //         this.selectedProject === this.isEditingRegularPayment.accounting.project &&
    //         this.employeeName === this.isEditingRegularPayment.accounting.recipient &&
    //         this.selectedDepartment === this.isEditingRegularPayment.accounting.department &&
    //         this.moreInfo === this.isEditingRegularPayment.accounting.desc &&
    //         this.selectedCurrency === this.currencyMap[this.isEditingRegularPayment.withdrawal.sourceCurrency] &&
    //         this.amount === this.isEditingRegularPayment.withdrawal.sourceAmount &&
    //         this.wallet === this.isEditingRegularPayment.withdrawal.wallet &&
    //         this.selectedRegularType === this.regularTypes[this.isEditingRegularPayment.interval.type] &&
    //         this.monthlyDay === this.isEditingRegularPayment.interval.monthlyDay &&
    //         this.delta === this.isEditingRegularPayment.interval.delta &&
    //         this.startPaymentDate === this.isEditingRegularPayment.interval.startDate
    //     ) {
    //         return true
    //     }
    //     return false
    // }
  },
  created() {
    this.getSavedCards()
    this.getSbpBanks()
    this.getFkSbpBanks()
    this.getCardLinkSbpMethods()
    this.getAddCardLink()
    this.getInfoAccounting()
    this.getAllInfoCommission()
    this.initListeners()
  },
  destroyed() {
    document.removeEventListener('keyup', this.withdrawOnEnter)
  },
  methods: {
    switchTab(value) {
      if (this.selectedTab === value) {
        return
      }
      this.clearParams()
      if (value === 2) {
        this.getRegularPayments()
        this.$store.commit('setDeleteRegularPayments', [])
      }
      this.selectedTab = value
    },
    openRegularForm() {
      this.createRegularPaymentFormOpen = !this.createRegularPaymentFormOpen
    },
    closeRegularForm() {
      this.clearParams()
      this.createRegularPaymentFormOpen = false
      this.$store.commit('setEditingRegularFormOpen', false)
    },
    getKeyByValue() {
      return Object.keys(this.currencyMap).find(
        (key) => this.currencyMap[key] === this.selectedCurrency
      )
    },
    getKeyByCurrencyAccounting() {
      return Object.keys(this.currencyMap).find(
        (key) => this.currencyMap[key] === this.selectedCurrencyAccounting
      )
    },
    openSelectType() {
      this.selectsOpen.payoutType = !this.selectsOpen.payoutType
    },
    openSelectBank() {
      this.selectsOpen.bank = !this.selectsOpen.bank
    },
    openSelectProject() {
      this.selectsOpen.project = !this.selectsOpen.project
    },
    openSelectKind() {
      this.selectsOpen.kind = !this.selectsOpen.kind
    },
    openSelectDepartment() {
      this.selectsOpen.department = !this.selectsOpen.department
    },
    openSelectTarget() {
      this.selectsOpen.target = !this.selectsOpen.target
    },
    openSelectSubTarget() {
      this.selectsOpen.subTarget = !this.selectsOpen.subTarget
    },
    openSelectCurrency() {
      this.selectsOpen.currency = !this.selectsOpen.currency
    },
    openSelectCurrencyAccounting() {
      this.selectsOpen.currencyAccounting = !this.selectsOpen.currencyAccounting
    },
    openSelectTypeRegularPayment() {
      this.selectsOpen.regularType = !this.selectsOpen.regularType
    },
    openCalendar() {
      this.openedCalendar = !this.openedCalendar
    },
    selectType(type, id) {
      this.wallet = ''
      this.withdrawalMethodId = id
      this.selectedType = type.charAt(0).toUpperCase() + type.slice(1)
      this.selectsOpen.payoutType = !this.selectsOpen.payoutType

      if (this.selectedType === 'Gm_cards') {
        this.getSavedCards()
      }
    },
    selectProject(index) {
      this.selectedProject = this.projects[index]
      this.selectsOpen.project = !this.selectsOpen.project
    },
    selectBank(bank) {
      this.selectedBank = bank
      this.selectsOpen.bank = !this.selectsOpen.bank
      this.bankName = ''
    },
    selectCardLinkBank(bank) {
      this.selectedCardLinkBank = bank
      this.selectsOpen.bank = !this.selectsOpen.bank
      this.bankName = ''
    },
    selectFkBank(bank) {
      this.selectedFkBank = bank
      this.selectsOpen.bank = !this.selectsOpen.bank
      this.bankName = ''
    },
    selectKind(key) {
      this.selectedKind = this.kinds[key]
      this.selectsOpen.kind = !this.selectsOpen.kind
    },
    selectDepartment(key) {
      this.selectedDepartment = this.departments[key]
      this.selectedDirection = 'Выберите направление'
      this.selectsOpen.department = !this.selectsOpen.department
    },
    openSelectDirection() {
      this.selectsOpen.direction = !this.selectsOpen.direction
    },
    selectDirection(direction) {
      this.selectedDirection = direction
      this.selectsOpen.direction = !this.selectsOpen.direction
    },
    selectTarget(key) {
      this.selectedSubTarget = 'Выберите подкатегорию'
      this.selectedTarget = key
      this.selectsOpen.target = !this.selectsOpen.target
    },
    selectSubTarget(item) {
      this.selectedSubTarget = item
      this.selectsOpen.subTarget = !this.selectsOpen.subTarget
    },
    selectCurrency(key, accounting) {
      if (accounting) {
        this.selectedCurrencyAccounting = this.currencyMap[key]
        this.selectsOpen.currencyAccounting = !this.selectsOpen.currencyAccounting
      } else {
        this.selectedCurrency = this.currencyMap[key]
        this.selectsOpen.currency = !this.selectsOpen.currency
        this.selectedType = 'Выберите метод'
        this.wallet = ''
      }
    },
    selectRegularType(type) {
      this.selectedRegularType = type
      this.selectsOpen.regularType = !this.selectsOpen.regularType
    },
    getWithdrawSum() {
      fetch(`https://payments.neuralgeneration.com/api/v1/withdrawals/admin-withdrawals-sum`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.$store.state.tokens.access}`
        }
      })
        .then((res) => res.json())
        .then((data) => {
          this.$store.commit('setCurrentSpent', data)
        })
    },
    getRegularPayments() {
      this.regularPaymentsLoader = true
      fetch(`https://payments.neuralgeneration.com/api/v1/withdrawals/acc_regular_fetch`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.$store.state.tokens.access}`
        }
      })
        .then((res) => res.json())
        .then((data) => {
          this.regularPayments = data.regulars
          this.regularPaymentsLoader = false
        })
    },
    async withDraw() {
      if (this.isBtnDisable || this.withdrawButtonDisable) {
        return
      }
      this.withdrawButtonDisable = true
      const accountingBody = {}
      accountingBody.project = this.selectedProject
      accountingBody.type = Object.keys(this.kinds).find(
        (key) => this.kinds[key] === this.selectedKind
      )
      accountingBody.psSourceCurrency = this.getKeyByCurrencyAccounting()
      if (this.kinds.once === this.selectedKind) {
        accountingBody.recipient = this.employeeName
        accountingBody.department = this.selectedDepartment
        if (this.directionsForSelected && this.selectedDirection !== 'Выберите направление') {
          accountingBody.direction = this.selectedDirection
        }
      }
      if (this.kinds.other === this.selectedKind) {
        accountingBody.desc = this.moreInfo
        accountingBody.enumDesc = this.selectedTarget
        accountingBody.department = this.selectedDepartment
      }

      if (this.accountingDate !== 'Select a date') {
        accountingBody.invoiceDateTime = this.accountingDate
      }
      const body = {
        withdrawalMethodId: this.withdrawalMethodId,
        wallet: this.wallet,
        sourceCurrency: this.getKeyByValue(),
        sourceAmount: this.amount,
        description: '',
        topt: this.twoFactor,
        accounting: accountingBody
      }
      if (this.selectedType === 'Sbp') {
        body.sbp_bank_id = this.selectedBank.id
      }
      if (this.selectedType === 'Fkwallet_sbp') {
        body.sbp_bank_id = this.selectedFkBank.id
      }
      if (this.selectedType === 'Credit_card' || this.selectedType === 'Cardlink_sbp') {
        body.payment_info = {}
        body.payment_info.add_first_name = this.firstName
        body.payment_info.add_last_name = this.secondName
      }
      if (this.selectedType === 'Cardlink_sbp') {
        body.payment_info.add_bank_id = this.selectedCardLinkBank.member_id
      }
      const response = await http.post(
        `https://payments.neuralgeneration.com/api/v1/withdrawals/acc_create`,
        body,
        cookie.get('token')
      )
      if (response.statusCode === 200) {
        this.amount = ''
        this.selectedType = 'Выберите метод'
        this.wallet = ''
        this.twoFactor = ''
        this.accountingDate = 'Select a date'
        this.success = true
        setTimeout(() => {
          if (this.isPermissions.admin_payments) {
            this.getBalance(this.isCurrency)
            this.getWithdrawSum()
          }
          this.success = false
        }, 2000)
      } else {
        this.error = true
        setTimeout(() => {
          this.error = false
        }, 2000)
      }
      this.withdrawButtonDisable = false
    },
    async createRegularPayment() {
      if (this.isCreateRegularBtnDisable || this.withdrawButtonDisable) {
        return
      }
      this.withdrawButtonDisable = true
      const accountingBody = {}
      accountingBody.project = this.selectedProject
      accountingBody.type = 'regular'
      accountingBody.recipient = this.employeeName
      accountingBody.department = this.selectedDepartment
      if (this.directionsForSelected && this.selectedDirection !== 'Выберите направление') {
        accountingBody.direction = this.selectedDirection
      }
      accountingBody.desc = this.moreInfo
      accountingBody.psSourceCurrency = this.getKeyByCurrencyAccounting()
      const interval = {}
      interval.type = Object.keys(this.regularTypes).find(
        (key) => this.regularTypes[key] === this.selectedRegularType
      )

      if (this.selectedRegularType === 'Месячная выплата') {
        interval.monthlyDay = this.monthlyDay
        interval.startDate = null
        interval.delta = null
      }

      if (this.selectedRegularType === 'Интервальная выплата') {
        interval.monthlyDay = null
        interval.startDate = this.startPaymentDate
        interval.delta = this.delta
      }
      const body = {
        withdrawalMethodId: this.withdrawalMethodId,
        wallet: this.wallet,
        sourceCurrency: this.getKeyByValue(),
        sourceAmount: this.amount,
        description: '',
        topt: this.twoFactor,
        accounting: accountingBody,
        interval: interval
      }
      if (this.selectedType === 'Sbp') {
        body.sbp_bank_id = this.selectedBank.id
      }
      if (this.selectedType === 'Fkwallet_sbp') {
        body.sbp_bank_id = this.selectedFkBank.id
      }
      const response = await http.post(
        `https://payments.neuralgeneration.com/api/v1/withdrawals/acc_regular_create`,
        body,
        cookie.get('token')
      )
      if (response.statusCode === 200) {
        this.clearParams()
        this.getRegularPayments()
        this.regularPaymentSuccess = true
        setTimeout(() => {
          this.regularPaymentSuccess = false
        }, 4000)
      } else {
        this.regularPaymentError = true
        setTimeout(() => {
          this.regularPaymentError = false
        }, 2000)
      }
      this.withdrawButtonDisable = false
    },
    async editRegularPayment() {
      this.withdrawButtonDisable = true
      const accountingBody = {}
      accountingBody.project = this.selectedProject
      accountingBody.type = 'regular'
      accountingBody.recipient = this.employeeName
      accountingBody.department = this.selectedDepartment
      if (this.directionsForSelected && this.selectedDirection !== 'Выберите направление') {
        accountingBody.direction = this.selectedDirection
      }
      accountingBody.desc = this.moreInfo
      accountingBody.psSourceCurrency = this.getKeyByCurrencyAccounting()
      const interval = {}
      interval.type = Object.keys(this.regularTypes).find(
        (key) => this.regularTypes[key] === this.selectedRegularType
      )

      if (this.selectedRegularType === 'Месячная выплата') {
        interval.monthlyDay = this.monthlyDay
        interval.startDate = null
        interval.delta = null
      }

      if (this.selectedRegularType === 'Интервальная выплата') {
        interval.monthlyDay = null
        interval.startDate = this.startPaymentDate
        interval.delta = this.delta
      }
      const body = {
        withdrawalMethodId: this.withdrawalMethodId,
        wallet: this.wallet,
        sourceCurrency: this.getKeyByValue(),
        sourceAmount: this.amount,
        description: '',
        topt: this.twoFactor,
        accounting: accountingBody,
        interval: interval,
        regularId: this.isEditingRegularPayment.id
      }
      if (this.selectedType === 'Sbp') {
        body.sbp_bank_id = this.selectedBank.id
      }
      if (this.selectedType === 'Fkwallet_sbp') {
        body.sbp_bank_id = this.selectedFkBank.id
      }
      const response = await http.post(
        `https://payments.neuralgeneration.com/api/v1/withdrawals/acc_regular_edit`,
        body,
        cookie.get('token')
      )
      if (response.statusCode === 200) {
        this.clearParams()
        this.getRegularPayments()
        this.regularPaymentSuccess = true
        setTimeout(() => {
          this.regularPaymentSuccess = false
        }, 4000)
      } else {
        this.regularPaymentError = true
        setTimeout(() => {
          this.regularPaymentError = false
        }, 2000)
      }
      this.withdrawButtonDisable = false
    },
    async deleteRegularPayment() {
      const response = await http.post(
        `https://payments.neuralgeneration.com/api/v1/withdrawals/acc_regular_delete`,
        {
          ids: this.isDeleteRegularPayments,
          topt: this.deleteFa
        },
        cookie.get('token')
      )
      if (response.statusCode === 200) {
        this.getRegularPayments()
        this.regularPaymentSuccess = true
        this.$store.commit('setDeleteRegularPayments', [])
        setTimeout(() => {
          this.regularPaymentSuccess = false
        }, 3000)
      } else {
        this.deleteError = true
        setTimeout(() => {
          this.deleteError = false
        }, 2000)
      }
      this.deleteFa = null
    },
    getBalance(currency) {
      fetch(
        `https://payments.neuralgeneration.com/api/v1/special/gm_balance?currency=${currency}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${this.$store.state.tokens.access}`
          }
        }
      )
        .then((res) => res.json())
        .then((data) => {
          const balance = data.balance
          this.$store.commit('setBalance', balance)
          this.$store.commit('setCurrency', currency)
        })
    },
    openGmCardsMenu() {
      this.cardsMenu.showList = true
      this.filterGmCards(this.cardsMenu.cards, this.gmCard)
    },
    filterGmCards(arrayOfCards, input) {
      return (this.filtredGmCards = arrayOfCards.filter((card) => card.includes(input)))
    },
    onChangeGmCard() {
      this.cardsMenu.showList = true
      this.filterGmCards(this.cardsMenu.cards, this.gmCard)
      this.wallet = this.gmCard
    },
    selectCard(index) {
      this.cardsMenu.selectedCardIndex = index
      this.cardsMenu.showList = false
      this.gmCard = this.filterGmCards(this.cardsMenu.cards, this.gmCard)[index]
      this.wallet = this.gmCard
    },
    async getSavedCards() {
      this.gmCard = ''
      const { data } = await http.get(
        `https://payments.neuralgeneration.com/api/v1/withdrawals/gm_cards`,
        cookie.get('token')
      )

      if (data && data.success) {
        this.cardsMenu.cards = data.pans
      }
    },
    async getSbpBanks() {
      this.sbpBanks = ''
      const { data } = await http.get(
        `https://payments.neuralgeneration.com/api/v1/withdrawals/get_sbp_bank_list`,
        cookie.get('token')
      )

      if (data && data.success) {
        this.sbpBanks = data.sbp_bank_list
      }
    },
    async getCardLinkSbpMethods() {
      const { data } = await http.get(
        `https://payments.neuralgeneration.com/api/v1/withdrawals/cardlink/sbp_methods`,
        cookie.get('token')
      )

      if (data) {
        this.cardLinkSbpMethods = data
      }
    },
    async getFkSbpBanks() {
      const { data } = await http.get(
        `https://payments.neuralgeneration.com/api/v1/withdrawals/fkwallet/sbp_methods`,
        cookie.get('token')
      )

      if (data) {
        this.fkSbpBanks = data
      }
    },
    async getInfoAccounting() {
      const response = await http.get(
        `https://payments.neuralgeneration.com/api/v1/withdrawals/acc_config`,
        cookie.get('token')
      )
      if (response) {
        this.projects = response.data.project
        this.departments = response.data.department
        this.departmentDirections = response.data.department_directions || {}
        this.target = response.data.targets
      }
    },
    async getAllInfoCommission() {
      const { data } = await http.get(
        `https://payments.neuralgeneration.com/api/v1/withdrawals/methods/fetch_all`,
        cookie.get('token')
      )

      if (data) {
        data.withdrawalMethods.forEach((m) => {
          const keys = Object.keys(this.methodsMap)

          if (!keys.includes(m.name)) {
            this.methodsMap[m.name] = {}
          }
          this.methodsMap[m.name][m.currency] = m
        })
      }
    },
    async getAddCardLink() {
      const { data } = await http.get(
        `https://payments.neuralgeneration.com/api/v1/withdrawals/card_link_for_gm`,
        cookie.get('token')
      )

      if (data && data.success) {
        this.cardsMenu.addCardLink = data.url
      }
    },
    closeByClickingOutCard(event) {
      const path = event.path || (event.composedPath && event.composedPath())
      if (
        event &&
        !path.find(
          (div) =>
            div.classList &&
            (div.classList.contains('accounting__form__input__chooseCard') ||
              div.classList.contains('card'))
        )
      ) {
        this.cardsMenu.showList = false
      }
    },
    closeByClickingOutCalendar(event) {
      const path = event.path || (event.composedPath && event.composedPath())
      if (
        event &&
        !path.find(
          (div) =>
            div.classList &&
            (div.classList.contains('accounting__form__calendar') ||
              div.classList.contains('accounting__form__calendarValue'))
        )
      ) {
        this.openedCalendar = false
      }
    },
    closeByClickingOutSelect(event) {
      const path = event.path || (event.composedPath && event.composedPath())
      if (event && !path.find((div) => div.classList && div.classList.contains('select'))) {
        this.selectsOpen.payoutType = false
        this.selectsOpen.project = false
        this.selectsOpen.kind = false
        this.selectsOpen.department = false
        this.selectsOpen.direction = false
        this.selectsOpen.currency = false
        this.selectsOpen.currencyAccounting = false
      }
    },
    withdrawOnEnter(event) {
      if (event.code === 'Enter') {
        this.withDraw()
      }
    },
    getCorrectDate(e) {
      this.accountingDate = e
      this.startPaymentDate = e
      this.openedCalendar = false
    },
    clearParams() {
      this.createRegularPaymentFormOpen = false
      this.$store.commit('setEditingRegularFormOpen', false)
      this.delta = null
      this.monthlyDay = null
      this.startPaymentDate = 'Select a date'
      this.twoFactor = null
      this.selectedRegularType = 'Выберите тип регулярной выплаты'
      this.wallet = null
      this.amount = 0
      this.selectedType = 'Выберите метод'
      this.moreInfo = null
      this.selectedDepartment = 'Выберите департамент'
      this.selectedDirection = 'Выберите направление'
      this.employeeName = null
      this.selectedProject = 'Выберите проект'
      this.startPaymentDate = 'Select a date'
      this.accountingDate = 'Select a date'
    },
    clearDate() {
      this.startPaymentDate = 'Select a date'
    },
    initListeners() {
      document.addEventListener('click', this.closeByClickingOutCard)
      document.addEventListener('click', this.closeByClickingOutSelect)
      document.addEventListener('click', this.closeByClickingOutCalendar)
      document.addEventListener('keyup', this.withdrawOnEnter)
    }
  }
}
</script>
